import {
  UNKNOWN_LEAVE_TYPE_LABEL,
  UNKNOWN_LEAVE_TYPE_SURFACE_COLOR,
  UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR
} from '@/services/availability/availability.types';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { cellBase } from './calendarCellStyles';

interface LeaveCellProps {
  isUnknown: boolean;
  label?: string;
  color?: string;
}

export const MyCalendarLeaveCell: FC<LeaveCellProps> = ({ isUnknown, label, color }) => (
  <div
    className="h-full px-5 flex justify-center items-center"
    style={{ backgroundColor: isUnknown ? UNKNOWN_LEAVE_TYPE_WRAPPER_COLOR : `${color}80` }}
  >
    <div
      className={twMerge(cellBase, 'py-4 px-8', isUnknown && 'border border-gray-300 bg-gray-200 text-gray-700')}
      style={{ backgroundColor: isUnknown ? UNKNOWN_LEAVE_TYPE_SURFACE_COLOR : color }}
    >
      {isUnknown ? UNKNOWN_LEAVE_TYPE_LABEL : label?.toUpperCase()}
    </div>
  </div>
);
